<template>
  <div class="modal-window uts004 mas025">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("entity.decision","의사결정") }}</div>
    </header>

    <div class="modal-content">
      <div class="tab_ty1" id="tabsTy3">
        <ul class="tab-menu">
          <li
            v-for="(tab, index) in tabsTy3"
            v-bind:class="{ active: currentTab3 === index }"
            :key="'tabsTy3_' + index"
          >
            <button type="button" v-on:click="handlerTabs3(index)">
              {{ tab }} <span class="ico-new" v-if="index == 1 && deciReadYn > 0"></span> 
            </button>
          </li>
        </ul>
        <div class="tab-content">
          <div v-show="currentTab3 == 0">
            <div class="tab_ty2" id="tabsTy4">
              <ul class="tab-menu">
                <li
                  v-for="(tab, index) in tabsTy4"
                  v-bind:class="{ active: currentTab4 === index }"
                  :key="'tabsTy4_' + index"
                >
                  <button type="button" v-on:click="currentTab4 = index">
                    {{ tab }}
                  </button>
                </li>
              </ul>
              <div class="tab-content">
                <div v-show="currentTab4 == 0">
                  <div class="tb-header clear">
                    <div class="tb_sort fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            :value="startDate"
                            @selected="selectedStartDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            :value="endDate"
                            @selected="selectedEndDate"
                          ></datepicker>
                        </div>
                      </div>
                      <FilterBoxPerDeci
                        :startDate="startDate"
                        :endDate="endDate"
                        filterInfo="fromMe"
                      />
                    </div>
                  </div>
                  <!-- //tb-header -->

                  <div class="decision-making todo clear col-3">
                    <div class="inner">
                      <div class="tit">
                        <!-- 승인 전 -->
                        {{ $i18nUtil.trans("entity.decision.status.proceeding","승인 전") }}&nbsp;<b>{{ listFromMeElseCount }}</b>
                      </div>
                      <div class="list_wrap">
                        <div
                          class="nodata"
                          v-if="kanban.listFromMeAppl.length == 0"
                        >
                          <div class="txt">{{ $i18nUtil.trans("search.046","요청한 의사결정 건이 없습니다.") }}</div>
                        </div>
                        <div
                          class="list"
                          v-for="(fromAppl, index) in kanban.listFromMeAppl"
                          :key="'listFromMeAppl' + index"
                          :transfer-data="fromAppl"
                        >
                          <div class="task_name">
                            <span
                              v-if="fromAppl.groupKbn == 'CFRC'"
                              class="task-cate"
                              >
                            {{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }}
                            </span>
                            <span
                              v-else-if="fromAppl.groupKbn == 'PRO'"
                              class="task-cate"
                              >{{$i18nUtil.trans("entity.project","과제")}}
                            </span>
                            <span
                              v-else-if="fromAppl.groupKbn == 'USER'"
                              class="task-cate"
                              >
                              {{ $i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗") }}
                            </span>
                            <span v-if="fromAppl.groupKbn != 'USER'"
                                  class="ell-singleline cursor-pointer"
                                  @click="linkedTarget(fromAppl.groupKbn, fromAppl)">
                              {{ fromAppl.projectName }}
                            </span>
                          </div>
                          <div
                            class="board_name ell-singleline"
                            @click="linkedTarget('PAPER', fromAppl)"
                          >
                            <template v-if="fromAppl.paperTitle != ''">
                              <span class="cursor-pointer">{{
                                fromAppl.paperTitle
                              }}</span>
                            </template>
                          </div>
                          <div
                            class="list-tit-s multi-ellipsis"
                            v-html="
                              fromAppl.contents.split('\n').join('<br />')
                            "
                            @click="openModal(fromAppl)"
                          ></div>
                          <div class="btm clear">
                            <div class="re-de fl">
                              <div class="re">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{
                                          fromAppl.regUserName
                                        }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip
                                        :userId="fromAppl.regUserId"
                                      />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                              <div class="division"></div>
                              <div class="de">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{ fromAppl.userName }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip :userId="fromAppl.userId" />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                            </div>
                            <div class="list-date fr">
                              {{
                                replaceAll(
                                  fromAppl.regDate.substring(0, 10),
                                  "-",
                                  "."
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <!--//list-->
                        <div
                          class="btn_box txtc"
                          v-if="listFromMeElseCount > listFromMeElse.length"
                        >
                          <button
                            type="button"
                            class="btn-more-ico_small1 down"
                            @click="addKanbanList('listFromMeElse')"
                          >
                            {{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: listFromMeElseCount - listFromMeElse.length > 5 ? 5 : listFromMeElseCount - listFromMeElse.length}) }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="inner">
                      <div class="tit clear">
                        <!-- 승인 -->
                        {{ $i18nUtil.trans("entity.decision.status.approval","승인") }}&nbsp;<b>{{ listFromMeCountAproval }}</b>
                      </div>
                      <div class="list_wrap">
                        <div
                          class="nodata"
                          v-if="kanban.listFromMeAproval.length == 0"
                        >
                          <div class="txt">
                            {{ $i18nUtil.trans("search.047","승인된 의사결정 건이 없습니다.") }}
                          </div>
                        </div>
                        <div
                          class="list"
                          v-for="(
                            fromAproval, index
                          ) in kanban.listFromMeAproval"
                          :key="'listFromMeAproval' + index"
                          :transfer-data="fromAproval"
                        >
                          <div class="task_name">
                            <span
                              v-if="fromAproval.groupKbn == 'CFRC'"
                              class="task-cate"
                              >
                              {{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }}
                            </span>
                            <span
                              v-if="fromAproval.groupKbn == 'PRO'"
                              class="task-cate"
                              >{{$i18nUtil.trans("entity.project","과제")}}
                            </span>
                            <span
                              v-if="fromAproval.groupKbn == 'USER'"
                              class="task-cate"
                              >
                              {{ $i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗") }}
                            </span>
                            <span
                              v-if="fromAproval.groupKbn != 'USER'"
                              class="ell-singleline cursor-pointer"
                              @click="linkedTarget(fromAproval.groupKbn, fromAproval)">
                              {{ fromAproval.projectName }}
                            </span>
                          </div>
                          <div
                            class="board_name ell-singleline"
                            @click="linkedTarget('PAPER', fromAproval)"
                          >
                            <template v-if="fromAproval.paperTitle != ''">
                              <span class="cursor-pointer">{{
                                fromAproval.paperTitle
                              }}</span>
                            </template>
                          </div>
                          <div
                            class="list-tit-s multi-ellipsis"
                            v-html="
                              fromAproval.contents.split('\n').join('<br />')
                            "
                            @click="openModal(fromAproval)"
                          ></div>
                          <div class="btm clear">
                            <div class="re-de fl">
                              <div class="re">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{
                                          fromAproval.regUserName
                                        }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip
                                        :userId="fromAproval.regUserId"
                                      />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                              <div class="division"></div>
                              <div class="de">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{
                                          fromAproval.userName
                                        }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip
                                        :userId="fromAproval.userId"
                                      />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                            </div>
                            <div class="list-date fr">
                              {{
                                replaceAll(
                                  fromAproval.regDate.substring(0, 10),
                                  "-",
                                  "."
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <!--//list-->
                        <div
                          class="btn_box txtc"
                          v-if="
                            listFromMeCountAproval > listFromMeAproval.length
                          "
                        >
                          <button
                            type="button"
                            class="btn-more-ico_small1 down"
                            @click="addKanbanList('listFromMeAproval')"
                          >
                            {{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: listFromMeCountAproval - listFromMeAproval.length > 5 ? 5 : listFromMeCountAproval - listFromMeAproval.length}) }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="inner">
                      <div class="tit clear">
                        <!-- 반려 -->
                        {{ $i18nUtil.trans("entity.decision.status.reject","반려") }}&nbsp;<b>{{ listFromMeCountReturn }}</b>
                      </div>
                      <div class="list_wrap">
                        <div
                          class="nodata"
                          v-if="kanban.listFromMeReturn.length == 0"
                        >
                          <div class="txt">
                            {{ $i18nUtil.trans("search.048","반려된 의사결정 건이 없습니다.") }}
                          </div>
                        </div>
                        <div
                          class="list"
                          v-for="(fromReturn, index) in kanban.listFromMeReturn"
                          :key="'listFromMeReturn' + index"
                          :transfer-data="fromReturn"
                        >
                          <div class="task_name ell-singleline">
                            <span
                              v-if="fromReturn.groupKbn == 'CFRC'"
                              class="task-cate"
                              >
                              {{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }}
                            </span>
                            <span
                              v-if="fromReturn.groupKbn == 'PRO'"
                              class="task-cate"
                              >{{$i18nUtil.trans("entity.project","과제")}}
                            </span>
                            <span
                              v-if="fromReturn.groupKbn == 'USER'"
                              class="task-cate"
                              >
                              {{ $i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗") }}
                            </span>
                            <span
                              v-if="fromReturn.groupKbn != 'USER'"
                              class="ell-singleline cursor-pointer"
                              @click="linkedTarget(fromReturn.groupKbn, fromReturn)">
                              {{ fromReturn.projectName }}
                            </span>
                          </div>
                          <div class="board_name">
                            <template
                              v-if="fromReturn.paperTitle != ''"
                            >
                              <span class="cursor-pointer"
                                    @click="linkedTarget('PAPER', fromReturn)">
                              {{ fromReturn.paperTitle }}</span>
                            </template>
                          </div>
                          <div
                            class="list-tit-s multi-ellipsis"
                            v-html="
                              fromReturn.contents.split('\n').join('<br />')
                            "
                            @click="openModal(fromReturn)"
                          ></div>
                          <div class="btm clear">
                            <div class="re-de fl">
                              <div class="re">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{
                                          fromReturn.regUserName
                                        }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip
                                        :userId="fromReturn.regUserId"
                                      />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                              <div class="division"></div>
                              <div class="de">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{ fromReturn.userName }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip
                                        :userId="fromReturn.userId"
                                      />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                            </div>
                            <div class="list-date fr">
                              {{
                                replaceAll(
                                  fromReturn.regDate.substring(0, 10),
                                  "-",
                                  "."
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <!--//list-->
                        <div
                          class="btn_box txtc"
                          v-if="listFromMeCountReturn > listFromMeReturn.length"
                        >
                          <button
                            type="button"
                            class="btn-more-ico_small1 down"
                            @click="addKanbanList('listFromMeReturn')"
                          >
                            {{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: listFromMeCountReturn - listFromMeReturn.length > 5 ? 5 : listFromMeCountReturn - listFromMeReturn.length}) }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="currentTab4 == 1">
                  <div class="tb-header clear">
                    <div class="tb_sort fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            :value="startDate"
                            @selected="selectedStartDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            :value="endDate"
                            @selected="selectedEndDate"
                          ></datepicker>
                        </div>
                      </div>
                      <FilterBoxPerDeci
                        :startDate="startDate"
                        :endDate="endDate"
                        filterInfo="fromMe"
                      />
                    </div>
                  </div>
                  <!-- //tb-header -->
                  <div class="scroll">
                    <v-data-table
                      :headers="headers"
                      :items="listFromFileList"
                      :sort-by="'newDate'"
                      :sort-desc="true"
                      :page.sync="page"
                      :items-per-page="itemsPerPage"
                      @page-count="pageCount = $event"
                      hide-default-footer
                      class="tb-contents uts004_table"
                    >
                      <template v-slot:[`header.reDe`]="{ header }">
                        <div class="re-de">
                          <div class="re">{{ header.re }}</div>
                          <div class="division"></div>
                          <div class="de">{{ header.de }}</div>
                        </div>
                      </template>

                      <template v-slot:[`item.todo`]="{ item }">
                        <div class="task_name ell-singleline">
                          <span>{{ item.task }}</span>
                          <span
                            class="cursor-pointer"
                            @click="linkedTarget(item.groupKbn, item)">
                            {{ item.sapce }}
                          </span>
                          <div
                            class="board_name"
                            @click="linkedTarget('PAPER', item)"
                          >
                            <span class="cursor-pointer">{{
                              item.boardName
                            }}</span>
                          </div>
                        </div>
                        <div
                          class="list-tit-s ell-singleline"
                          @click="openModal(item)"
                        >
                          {{ item.todo }}
                        </div>
                      </template>

                      <template v-slot:[`item.reDe`]="{ item }">
                        <div class="re-de">
                          <div class="re">
                            <div class="droplayer tooltipmember relative">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on"
                                    ><b>{{ item.re }}</b></v-btn
                                  >
                                </template>
                                <div class="dropdown-list">
                                  <UserTooltip :userId="item.regUserId" />
                                </div>
                              </v-menu>
                            </div>
                          </div>
                          <div class="division"></div>
                          <div class="de">
                            <div class="droplayer tooltipmember relative">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on"
                                    ><b>{{ item.de }}</b></v-btn
                                  >
                                </template>
                                <div class="dropdown-list">
                                  <UserTooltip :userId="item.chargerId" />
                                </div>
                              </v-menu>
                            </div>
                          </div>
                        </div>
                      </template>

                      <template v-slot:[`item.finDate`]="{ item }">
                        <div :class="item.finDateDeadline">
                          {{ item.finDate }}
                        </div>
                      </template>

                      <template slot="no-data">
                        <div class="nodata-txt-noicon">
                          <v-alert :value="true">
                            {{ $i18nUtil.trans("search.046","요청한 의사결정 건이 없습니다.") }}
                          </v-alert>
                        </div>
                      </template>
                    </v-data-table>
                    <div class="pagination">
                      <v-pagination
                        v-model="listFromFileListPage"
                        circle
                        :length="pageCountFrom"
                        :total-visible="7"
                        @input="onPageChange('listFromFileList')"
                      ></v-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="currentTab3 == 1">
            <div class="tab_ty2" id="tabsTy5">
              <ul class="tab-menu">
                <li
                  v-for="(tab, index) in tabsTy4"
                  v-bind:class="{ active: currentTab4 === index + 2 }"
                  :key="'tabsTy5_' + index"
                >
                  <button type="button" v-on:click="currentTab4 = index + 2">
                    {{ tab }}
                  </button>
                </li>
              </ul>
              <div class="tab-content">
                <div v-show="currentTab4 == 2">
                  <div class="tb-header clear">
                    <div class="tb_sort fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            :value="startDate"
                            @selected="selectedStartDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            :value="endDate"
                            @selected="selectedEndDate"
                          ></datepicker>
                        </div>
                        <div class="calendar_box hidden"></div>
                      </div>
                      <FilterBoxPerDeci
                        :startDate="startDate"
                        :endDate="endDate"
                        filterInfo="toMe"
                      />
                    </div>
                  </div>
                  <!-- //tb-header -->

                  <div class="decision-making todo clear col-3">
                    <div class="inner">
                      <div class="tit">
                        <!-- 승인 전 -->
                        {{ $i18nUtil.trans("entity.decision.status.proceeding","승인 전") }}&nbsp;<b>{{ listToMeElseCount }}</b>
                      </div>
                      <div class="list_wrap">
                        <div
                          class="nodata"
                          v-if="kanban.listToMeAppl.length == 0"
                        >
                          <div class="txt">
                            {{ $i18nUtil.trans("search.049","요청받은 의사결정 건이 없습니다.") }}
                          </div>
                        </div>
                        <div
                          class="list"
                          v-for="(ToAppl, index) in kanban.listToMeAppl"
                          :key="'listToMeAppl' + index"
                          :transfer-data="ToAppl"
                        >
                          <div class="task_name ell-singleline">
                            <span
                              v-if="ToAppl.groupKbn == 'CFRC'"
                              class="task-cate"
                              >
                              {{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }}
                            </span>
                            <span
                              v-if="ToAppl.groupKbn == 'PRO'"
                              class="task-cate"
                              >{{$i18nUtil.trans("entity.project","과제")}}
                            </span>
                            <span
                              v-if="ToAppl.groupKbn == 'USER'"
                              class="task-cate"
                              >
                              {{ $i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗") }}
                            </span>
                            <span
                              v-if="ToAppl.groupKbn != 'USER'"
                              class="ell-singleline cursor-pointer"
                              @click="linkedTarget(ToAppl.groupKbn, ToAppl)">
                              {{ ToAppl.projectName }}
                            </span>
                          </div>
                          <div
                            class="board_name ell-singleline"
                            @click="linkedTarget('PAPER', ToAppl)"
                          >
                            <template v-if="ToAppl.paperTitle != ''">
                              <span class="cursor-pointer">{{
                                ToAppl.paperTitle
                              }}</span>
                            </template>
                          </div>
                          <div
                            class="list-tit-s multi-ellipsis"
                            v-html="ToAppl.contents.split('\n').join('<br />')"
                            @click="openModal2(ToAppl)"
                          ></div>
                          <div class="btm clear">
                            <div class="re-de fl">
                              <div class="re">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{ ToAppl.regUserName }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip :userId="ToAppl.regUserId" />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                              <div class="division"></div>
                              <div class="de">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{ ToAppl.userName }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip :userId="ToAppl.userId" />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                            </div>
                            <div class="list-date fr">
                              {{
                                replaceAll(
                                  ToAppl.regDate.substring(0, 10),
                                  "-",
                                  "."
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <!--//list-->
                        <div
                          class="btn_box txtc"
                          v-if="listToMeElseCount > listToMeElse.length"
                        >
                          <button
                            type="button"
                            class="btn-more-ico_small1 down"
                            @click="addKanbanList('listToMeElse')"
                          >
                            {{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: listToMeElseCount - listToMeElse.length > 5 ? 5 : listToMeElseCount - listToMeElse.length}) }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="inner">
                      <div class="tit clear">
                        <!-- 승인 -->
                        {{ $i18nUtil.trans("entity.decision.status.approval","승인") }}&nbsp;<b>{{ listToMeCountAproval }}</b>
                      </div>
                      <div class="list_wrap">
                        <div
                          class="nodata"
                          v-if="kanban.listToMeAproval.length == 0"
                        >
                          <div class="txt">
                            {{ $i18nUtil.trans("search.047","승인된 의사결정 건이 없습니다.") }}
                          </div>
                        </div>
                        <div
                          class="list"
                          v-for="(ToAproval, index) in kanban.listToMeAproval"
                          :key="'listToMeAproval' + index"
                          :transfer-data="ToAproval"
                        >
                          <div class="task_name">
                            <span
                              v-if="ToAproval.groupKbn == 'CFRC'"
                              class="task-cate"
                              >
                              {{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }}
                            </span>
                            <span
                              v-if="ToAproval.groupKbn == 'PRO'"
                              class="task-cate"
                              >{{$i18nUtil.trans("entity.project","과제")}}
                            </span>
                            <span
                              v-if="ToAproval.groupKbn == 'USER'"
                              class="task-cate"
                              >
                              {{ $i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗") }}
                            </span>
                            <span
                              v-if="ToAproval.groupKbn != 'USER'"
                              class="ell-singleline cursor-pointer"
                              @click="linkedTarget(ToAproval.groupKbn, ToAproval)">
                              {{ ToAproval.projectName }}
                            </span>
                          </div>
                          <div class="board_name ell-singleline">
                            <template v-if="ToAproval.paperTitle != ''">
                              <span class="cursor-pointer"
                                    @click="linkedTarget('PAPER', ToAproval)">
                              {{ ToAproval.paperTitle }}</span>
                            </template>
                          </div>
                          <div
                            class="list-tit-s multi-ellipsis"
                            v-html="ToAproval.contents.split('\n').join('<br />')"
                            @click="openModal2(ToAproval)"
                          ></div>
                          <div class="btm clear">
                            <div class="re-de fl">
                              <div class="re">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{
                                          ToAproval.regUserName
                                        }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip
                                        :userId="ToAproval.regUserId"
                                      />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                              <div class="division"></div>
                              <div class="de">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{ ToAproval.userName }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip :userId="ToAproval.userId" />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                            </div>
                            <div class="list-date fr">
                              {{
                                replaceAll(
                                  ToAproval.regDate.substring(0, 10),
                                  "-",
                                  "."
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <!--//list-->
                        <div
                          class="btn_box txtc"
                          v-if="listToMeCountAproval > listToMeAproval.length"
                        >
                          <button
                            type="button"
                            class="btn-more-ico_small1 down"
                            @click="addKanbanList('listToMeElse')"
                          >
                            {{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: listToMeCountAproval - listToMeAproval.length > 5 ? 5 : listToMeCountAproval - listToMeAproval.length}) }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="inner">
                      <div class="tit clear">
                        <!-- 반려 -->
                        {{ $i18nUtil.trans("entity.decision.status.reject","반려") }}&nbsp;<b>{{ listToMeCountReturn }}</b>
                      </div>
                      <div class="list_wrap">
                        <div
                          class="nodata"
                          v-if="kanban.listToMeReturn.length == 0"
                        >
                          <div class="txt">
                            {{ $i18nUtil.trans("search.048","반려된 의사결정 건이 없습니다.") }}
                          </div>
                        </div>
                        <div
                          class="list"
                          v-for="(ToReturn, index) in kanban.listToMeReturn"
                          :key="'listToMeReturn' + index"
                          :transfer-data="ToReturn"
                        >
                          <div class="task_name">
                            <span
                              v-if="ToReturn.groupKbn == 'CFRC'"
                              class="task-cate"
                              >
                              {{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }}
                            </span>
                            <span
                              v-if="ToReturn.groupKbn == 'PRO'"
                              class="task-cate"
                              >{{$i18nUtil.trans("entity.project","과제")}}
                            </span>
                            <span
                              v-if="ToReturn.groupKbn == 'USER'"
                              class="task-cate"
                              >
                              {{ $i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗") }}
                            </span>
                            <span
                              v-if="ToReturn.groupKbn != 'USER'"
                              class="ell-singleline cursor-pointer"
                              @click="linkedTarget(ToReturn.groupKbn, ToReturn)">
                              {{ ToReturn.projectName }}
                            </span>
                          </div>
                          <div class="board_name ell-singleline">
                            <template
                              v-if="ToReturn.paperTitle != ''"
                            >
                              <span class="cursor-pointer"
                                    @click="linkedTarget('PAPER', ToReturn)">
                                {{ ToReturn.paperTitle }}</span
                              >
                            </template>
                          </div>
                          <div
                            class="list-tit-s multi-ellipsis"
                            v-html="
                              ToReturn.contents.split('\n').join('<br />')
                            "
                            @click="openModal2(ToReturn)"
                          ></div>
                          <div class="btm clear">
                            <div class="re-de fl">
                              <div class="re">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{
                                          ToReturn.regUserName
                                        }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip
                                        :userId="ToReturn.regUserId"
                                      />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                              <div class="division"></div>
                              <div class="de">
                                <div class="droplayer tooltipmember relative">
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on"
                                        ><b>{{ ToReturn.userName }}</b></v-btn
                                      >
                                    </template>
                                    <div class="dropdown-list">
                                      <UserTooltip :userId="ToReturn.userId" />
                                    </div>
                                  </v-menu>
                                </div>
                              </div>
                            </div>
                            <div class="list-date fr">
                              {{
                                replaceAll(
                                  ToReturn.regDate.substring(0, 10),
                                  "-",
                                  "."
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <!--//list-->
                        <div
                          class="btn_box txtc"
                          v-if="listToMeCountReturn > listToMeReturn.length"
                        >
                          <button
                            type="button"
                            class="btn-more-ico_small1 down"
                            @click="addKanbanList('listToMeElse')"
                          >
                            {{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: listToMeCountReturn - listToMeReturn.length > 5 ? 5 : listToMeCountReturn - listToMeReturn.length}) }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="currentTab4 == 3">
                  <div class="tb-header clear">
                    <div class="tb_sort fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            :value="startDate"
                            @selected="selectedStartDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            :value="endDate"
                            @selected="selectedEndDate"
                          ></datepicker>
                        </div>
                        <div class="calendar_box hidden"></div>
                      </div>
                      <FilterBoxPerDeci
                        :startDate="startDate"
                        :endDate="endDate"
                        filterInfo="toMe"
                      />
                    </div>
                  </div>
                  <!-- //tb-header -->
                  <div class="scroll">
                    <v-data-table
                      :headers="headers"
                      :items="listToFileList"
                      :sort-by="'newDate'"
                      :sort-desc="true"
                      :page.sync="page"
                      :items-per-page="itemsPerPage"
                      @page-count="pageCount = $event"
                      hide-default-footer
                      class="tb-contents uts004_table"
                    >
                      <template v-slot:[`header.reDe`]="{ header }">
                        <div class="re-de">
                          <div class="re">{{ header.re }}</div>
                          <div class="division"></div>
                          <div class="de">{{ header.de }}</div>
                        </div>
                      </template>

                      <template v-slot:[`item.todo`]="{ item }">
                        <div class="task_name ell-singleline">
                          <span>{{ item.task }}</span>
                          <span
                            class="cursor-pointer"
                            @click="linkedTarget(item.groupKbn, item)">
                            {{ item.sapce }}
                          </span>
                          <div
                            class="board_name"
                            @click="linkedTarget('PAPER', item)"
                          >
                            <span class="cursor-pointer">{{item.boardName}}</span>
                          </div>
                        </div>
                        <div
                          class="list-tit-s ell-singleline"
                          @click="openModal2(item)"
                        >
                          {{ item.todo }}
                        </div>
                      </template>

                      <template v-slot:[`item.reDe`]="{ item }">
                        <div class="re-de">
                          <div class="re">
                            <div class="droplayer tooltipmember relative">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on"
                                    ><b>{{ item.re }}</b></v-btn
                                  >
                                </template>
                                <div class="dropdown-list">
                                  <UserTooltip :userId="item.regUserId" />
                                </div>
                              </v-menu>
                            </div>
                          </div>
                          <div class="division"></div>
                          <div class="de">
                            <div class="droplayer tooltipmember relative">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on"
                                    ><b>{{ item.de }}</b></v-btn
                                  >
                                </template>
                                <div class="dropdown-list">
                                  <UserTooltip :userId="item.chargerId" />
                                </div>
                              </v-menu>
                            </div>
                          </div>
                        </div>
                      </template>

                      <template v-slot:[`item.finDate`]="{ item }">
                        <div :class="item.finDateDeadline">
                          {{ item.finDate }}
                        </div>
                      </template>

                      <template slot="no-data">
                        <div class="nodata-txt-noicon">
                          <v-alert :value="true">
                            {{ $i18nUtil.trans("search.049","요청받은 의사결정 건이 없습니다.") }}
                          </v-alert>
                        </div>
                      </template>
                    </v-data-table>
                    <div class="pagination">
                      <v-pagination
                        v-model="listToFileListPage"
                        circle
                        :length="pageCountTo"
                        :total-visible="7"
                        @input="onPageChange('listToFileList')"
                      ></v-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FilterBoxPerDeci from "./FilterBoxPerDeci";
import Datepicker from "vuejs-datepicker";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import MyModalU from "@/components/cowork/general/board/opinion/BoardOpinionModalU.vue";
import MyModal from "@/components/cowork/general/board/opinion/BoardOpinionModal.vue";
import EventBus from "@/js/eventbus/eventBus";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
  components: {
    FilterBoxPerDeci,
    Datepicker,
    UserTooltip,
  },
  data() {
    return {
      date: "2020.12.31",
      currentTab3: 0,
      currentTab4: 0,
      // currentTab5: 0,
      tabsTy3: [this.$i18nUtil.trans("message.PerDeci.001","요청한 의사결정"), this.$i18nUtil.trans("message.PerDeci.002","요청 받은 의사결정")],
      tabsTy4: [this.$i18nUtil.trans("message.PerDeci.003","칸반"), this.$i18nUtil.trans("message.PerDeci.004","리스트")],
      // tabsTy5: ["칸반", "리스트"],
      show: "true",
      hide: "false",

      page: 1,
      listFromFileListPage: 1,
      listToFileListPage: 1,
      pageCount: 0,
      pageCountTo: 0,
      pageCountFrom: 0,
      itemsPerPage: 20,
      headers: [
        { text: this.$i18nUtil.trans("entity.decision.filter.status","상태"), value: "status", sortable: false },
        { text: this.$i18nUtil.trans("entity.decision.filter.contents","의사결정 내용"), value: "todo", sortable: false },
        {
          re: this.$i18nUtil.trans("entity.decision.filter.reqUser","요청자"),
          align: "center",
          de: this.$i18nUtil.trans("entity.decision.filter.receiver","결정자"),
          value: "reDe",
          sortable: false,
        },
        { text: this.$i18nUtil.trans("entity.decision.filter.regDate","등록일"), align: "center", value: "newDate", sortable: false },
      ],
      fileList: [],

      startDate: "",
      endDate: "",
      // startDisabledDate: {
      //   from: ""
      // },
      // endDisabledDate: {
      //   to: ""
      // },
      userInfo: {},

      listToFileList: [],
      listFromFileList: [],

      kanban: {
        listFromMeAppl: [],
        listFromMeAproval: [],
        listFromMeReturn: [],
        listToMeAppl: [],
        listToMeAproval: [],
        listToMeReturn: [],
      },

      listToData: [],
      listFromData: [],

      listToMeElse: [],
      listToMeAproval: [],
      listToMeReturn: [],
      listFromMeElse: [],
      listFromMeAproval: [],
      listFromMeReturn: [],
      listToMeElseCount: 0,
      listToMeCountAproval: 0,
      listToMeCountReturn: 0,
      listFromMeElseCount: 0,
      listFromMeCountAproval: 0,
      listFromMeCountReturn: 0,

      filter: {
        space: "",
        spaceName: "",
        category: [],
        categoryName: null,
        board: [],
        boardName: null,
        targetUser: [],
        targetUserName: null,
        regUser: [],
        regUserName: null,
        status: 0,
      },

      deciReadYn : 0,
    };
  },
  created() {
    this.checkDeciConfirm();

    let date = new Date();
    date.setDate(date.getDate() - 7);
    this.startDate = new Date(date);
    this.endDate = new Date();

    EventBus.$on("refreshPerDeciNewPage", (payload) => {
      this.listMineAll();
      this.checkDeciConfirm();
    });

    EventBus.$on("FilterBoxDeciSetSpace", (payload) => {
      this.filter.space = payload;
      if (payload === "PRO") {
        this.filter.spaceName = this.$i18nUtil.trans("entity.project","과제");
      } else if (payload === "USER") {
        this.filter.spaceName = this.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗");
      } else if (payload === "CFRC") {
        this.filter.spaceName = this.$i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의");
      } else {
        this.filter.spaceName = "";
      }
    });
    EventBus.$on("FilterBoxDeciSetCategory", (payload) => {
      this.filter.category = payload;
      this.getFilterCategoryName();
      this.listFromSort();
    });
    EventBus.$on("FilterBoxDeciSetBoard", (payload) => {
      this.filter.board = payload;
      this.getFilterBoardName();
      this.listFromSort();
    });
    EventBus.$on("FilterBoxDeciSetTargetUser", (payload) => {
      this.filter.targetUser = payload;
      this.getFilterTargetUserName();
      this.listFromSort();
    });
    EventBus.$on("FilterBoxDeciSetTargetRegUser", (payload) => {
      this.filter.regUser = payload;
      this.getFilterRegUserName();
      this.listFromSort();
    });
    EventBus.$on("FilterBoxDeciSetStatus", (payload) => {
      this.filter.status = payload;
      this.listFromSort();
    });
  },
  watch: {
    // startDate() {
    //   let obj = this;
    //   let start = obj.$moment(this.startDate).format("YYYY.MM.DD");
    //   let end = obj.$moment(this.endDate).format("YYYY.MM.DD");
    //   if (start > end) {
    //     this.endDate = this.startDate;
    //   }
    // },
    // endDate() {
    //   let obj = this;
    //   let start = obj.$moment(this.startDate).format("YYYY.MM.DD");
    //   let end = obj.$moment(this.endDate).format("YYYY.MM.DD");
    //   if (start > end) {
    //     this.startDate = this.endDate;
    //   }
    // },
    currentTab4: function () {
      this.listMineAll();
    },
  },
  mounted() {
    //  let datepicker = document.querySelectorAll("div.vdp-datepicker div input");
    // for (let i = 0; i < datepicker.length; i++) {
    //   datepicker[i].onfocus = function () {
    //     datepicker[i].blur();
    //   };
    // }
    this.multiElipsis(2);
    // left 메뉴 알림 모달창에서 할 일 관련 이벤트 발생시. 탭선택.
    if(this.$route.query.index != null && this.$route.query.index == 1){
      let index = this.$route.query.index;
      this.currentTab3 = 1;
      this.currentTab4 = 2;
    }

    this.listMineAll();
    this.getUserInfo();
  },
  methods: {
    ...mapActions("modals", ["showModal"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    getUserInfo() {
      let userInfo = "/api/copaper/decision/userInfo";
      this.$axios.post(userInfo).then((response) => {
      this.userInfo = response.data.result;
      if(this.userInfo.deciRoleYn){
        this.currentTab3 = 1;
        this.currentTab4 = 2;
        }
      });
    },
    listMineAll() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        tabs: this.currentTab4.toString(),
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
      };
      reqData.req = obj.req;
      // reqData.url = "/api/copaper/maindecision/popupList";
      reqData.url = "/api/copaper/maindecision/popupListFirst";
      reqData.method = "post";

      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        let res = response.result;
        
        // locale에 따른 사용자 이름 영문 처리
        let key = Object.keys(res);
        key.forEach(item => {
          if(!item.toLowerCase().includes("count")) {
            let result = res[item];
            for(var i=0; i<result.length; i++) {
              if(obj.$i18nUtil.getLanguage() === 'ko') {
              }else{
                result[i].regUserName = result[i].regUserNameEn != null ? result[i].regUserNameEn : result[i].regUserName;
                result[i].userName = result[i].userNameEn != null ? result[i].userNameEn : result[i].userName;
              }
            }
          }
        })

        if (this.currentTab4 == 0) {
          this.listFromMeElse = res.listFromMeElse;
          this.listFromMeAproval = res.listFromMeAproval;
          this.listFromMeReturn = res.listFromMeReturn;
          this.listFromMeElseCount = res.listFromMeElseCount;
          this.listFromMeCountAproval = res.listFromMeCountAproval;
          this.listFromMeCountReturn = res.listFromMeCountReturn;
          this.kanbanSortAll();
        } else if (this.currentTab4 == 1) {
          this.listFromData = res.listFromMe;
          this.pageCountFrom = res.pageCountFrom;
          this.listFromSort();
        } else if (this.currentTab4 == 2) {
          this.listToMeElse = res.listToMeElse;
          this.listToMeAproval = res.listToMeAproval;
          this.listToMeReturn = res.listToMeReturn;
          this.listToMeElseCount = res.listToMeElseCount;
          this.listToMeCountAproval = res.listToMeCountAproval;
          this.listToMeCountReturn = res.listToMeCountReturn;
          this.kanbanSortAll();
        } else {
          this.listToData = res.listToMe;
          this.pageCountTo = res.pageCountTo;
          this.listToSort();
        }
      });
    },

    listFromSort() {
      let listFrom = this.listFromData;
      let listForm = {};
      let today = new Date();
      this.listFromFileList = [];
      for (let i = 0; i < listFrom.length; i++) {
        listForm = {
          id: null,
          status: this.$i18nUtil.trans("entity.decision.filter.status","상태"),
          re: this.$i18nUtil.trans("entity.decision.filter.reqUser","요청자"),
          de: this.$i18nUtil.trans("entity.decision.filter.receiver","결정자"),
          task: this.$i18nUtil.trans("entity.decision.filter.task","공간구분"),
          sapce: this.$i18nUtil.trans("entity.decision.filter.space","공간명"),
          boardName: this.$i18nUtil.trans("entity.decision.filter.boardName","보드명"),
          todo: this.$i18nUtil.trans("entity.decision.filter.contents","의사결정 내용"),
          newDate: this.$i18nUtil.trans("entity.decision.filter.regDate","등록일"),
          chargerId: "",
          regUserId: "",
          groupId: "",
          paperId: "",
          deciId: "",
        };
        listForm.id = i + "listFromFileList";
        listForm.deciId = listFrom[i].deciId;
        listForm.groupId = listFrom[i].groupId;
        listForm.paperId = listFrom[i].paperId;
        listForm.re = listFrom[i].regUserName;
        listForm.de = listFrom[i].userName;
        if (listFrom[i].status == "APPL") {
          listForm.status = this.$i18nUtil.trans("entity.decision.status.proceeding","승인 전");
        } else if (listFrom[i].status == "APROVAL") {
          listForm.status = this.$i18nUtil.trans("entity.decision.status.approval","승인");
        } else if (listFrom[i].status == "RETURN") {
          listForm.status = this.$i18nUtil.trans("entity.decision.status.reject","반려");
        }
        if (listFrom[i].groupKbn == "PRO") {
          listForm.task = this.$i18nUtil.trans("entity.project","과제");
        } else if (listFrom[i].groupKbn == "USER") {
          listForm.task = this.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗");
        } else if (listFrom[i].groupKbn == "CFRC") {
          listForm.task = this.$i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의");
        }
        listForm.sapce = listFrom[i].projectName;

        listForm.todo = listFrom[i].contents;
        listForm.newDate = this.replaceAll(
          listFrom[i].regDate.substring(0, 10),
          "-",
          "."
        );

        listForm.regUserId = listFrom[i].regUserId;
        listForm.chargerId = listFrom[i].userId;
        if (this.FromMeFilter(listFrom[i])) {
          this.listFromFileList.push(listForm);
        }
      }
      // this.listToSort();
    },
    listToSort() {
      let listTo = this.listToData;
      let listForm = {};
      let today = new Date();
      this.listToFileList = [];
      for (let i = 0; i < listTo.length; i++) {
        listForm = {
          id: null,
          status: this.$i18nUtil.trans("entity.decision.filter.status","상태"),
          re: this.$i18nUtil.trans("entity.decision.filter.reqUser","요청자"),
          de: this.$i18nUtil.trans("entity.decision.filter.receiver","결정자"),
          task: this.$i18nUtil.trans("entity.decision.filter.task","공간구분"),
          sapce: this.$i18nUtil.trans("entity.decision.filter.space","공간명"),
          boardName: this.$i18nUtil.trans("entity.decision.filter.boardName","보드명"),
          todo: this.$i18nUtil.trans("entity.decision.filter.contents","의사결정 내용"),
          newDate: this.$i18nUtil.trans("entity.decision.filter.regDate","등록일"),
          chargerId: "",
          regUserId: "",
          groupId: "",
          paperId: "",
          deciId: "",
        };
        listForm.id = i + "listToFileList";
        listForm.deciId = listTo[i].deciId;
        listForm.groupId = listTo[i].groupId;
        listForm.paperId = listTo[i].paperId;
        listForm.re = listTo[i].regUserName;
        listForm.de = listTo[i].userName;
        listForm.paperTitle = listTo[i].paperTitle;
        if (listTo[i].status == "APPL") {
          listForm.status = this.$i18nUtil.trans("entity.decision.status.proceeding","승인 전");
        } else if (listTo[i].status == "APROVAL") {
          listForm.status = this.$i18nUtil.trans("entity.decision.status.approval","승인");
        } else if (listTo[i].status == "RETURN") {
          listForm.status = this.$i18nUtil.trans("entity.decision.status.reject","반려");
        }
        if (listTo[i].groupKbn == "PRO") {
          listForm.task = this.$i18nUtil.trans("entity.project","과제");
        } else if (listTo[i].groupKbn == "USER") {
          listForm.task = this.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗");
        } else if (listTo[i].groupKbn == "CFRC") {
          listForm.task = this.$i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의");
        }
        listForm.sapce = listTo[i].projectName;

        listForm.todo = listTo[i].contents;
        listForm.newDate = this.replaceAll(
          listTo[i].regDate.substring(0, 10),
          "-",
          "."
        );

        listForm.regUserId = listTo[i].regUserId;
        listForm.chargerId = listTo[i].userId;
        if (this.FromMeFilter(listTo[i])) {
          this.listToFileList.push(listForm);
        }
      }
      // this.setDisabledDate();
      // this.kanbanSortAll();
    },
    kanbanSortAll() {
      if (this.currentTab4 == 0) {
        this.kanban.listFromMeAppl = [];
        this.kanban.listFromMeAproval = [];
        this.kanban.listFromMeReturn = [];
        this.kanbanSort(this.listFromMeElse, "listFromMeElse");
        this.kanbanSort(this.listFromMeAproval, "listFromMeAproval");
        this.kanbanSort(this.listFromMeReturn, "listFromMeReturn");
      } else {
        this.kanban.listToMeAppl = [];
        this.kanban.listToMeAproval = [];
        this.kanban.listToMeReturn = [];

        this.kanbanSort(this.listToMeElse, "listToMeElse");
        this.kanbanSort(this.listToMeAproval, "listToMeAproval");
        this.kanbanSort(this.listToMeReturn, "listToMeReturn");
      }
    },
    kanbanSort(param, param2) {
      for (let i = 0; i < param.length; i++) {
        if (param2 === "listToMeElse" && this.ToMeFilter(param[i])) {
          this.kanban.listToMeAppl.push(param[i]);
        } else if (param2 === "listToMeAproval" && this.ToMeFilter(param[i])) {
          this.kanban.listToMeAproval.push(param[i]);
        } else if (param2 === "listToMeReturn" && this.ToMeFilter(param[i])) {
          this.kanban.listToMeReturn.push(param[i]);
        } else if (param2 === "listFromMeElse" && this.FromMeFilter(param[i])) {
          this.kanban.listFromMeAppl.push(param[i]);
        } else if (
          param2 === "listFromMeAproval" &&
          this.FromMeFilter(param[i])
        ) {
          this.kanban.listFromMeAproval.push(param[i]);
        } else if (
          param2 === "listFromMeReturn" &&
          this.FromMeFilter(param[i])
        ) {
          this.kanban.listFromMeReturn.push(param[i]);
        }
      }
    },

    FromMeFilter(item) {
      let returnParam = true;
      if (
        this.filter.space == "" &&
        this.filter.targetUser.length == 0 &&
        this.filter.status == 0
      ) {
        return true;
      }
      if (this.filter.space != "") {
        returnParam = false;
        console.log(item);
        console.log(this.filter.space);
        if (item.groupKbn === this.filter.space) {
          returnParam = true;
        }
      }
      if (this.filter.category.length > 0) {
        returnParam = false;
        if (this.filter.space === "PRO") {
          for (let j = 0; j < this.filter.category.length; j++) {
            if (item.groupId === this.filter.category[j]) {
              returnParam = true;
            }
          }
        } else {
          for (let j = 0; j < this.filter.category.length; j++) {
            if (item.projectId === this.filter.category[j]) {
              returnParam = true;
            }
          }
        }
      }
      if (this.filter.board.length > 0) {
        returnParam = false;
        for (let j = 0; j < this.filter.board.length; j++) {
          if (item.paperId === this.filter.board[j]) {
            returnParam = true;
          }
        }
      }

      if (this.filter.targetUser != "") {
        let targetUserReturnParam = false;
        returnParam = false;
        for (let i = 0; i < this.filter.targetUser.length; i++) {
          if (item.chargerId === this.filter.targetUser[i]) {
            targetUserReturnParam = true;
          }
        }
        if (targetUserReturnParam) {
          returnParam = true;
        }
      }
      if (this.filter.status != 0) {
        returnParam = false;
        let statusReturnParam = false;
        if (this.filter.status == 1 && item.terDate == null) {
          statusReturnParam = true;
        } else if (this.filter.status == 2 && item.terDate != null) {
          statusReturnParam = true;
        }

        if (statusReturnParam) {
          returnParam = true;
        }
      }

      return returnParam;
    },
    ToMeFilter(item) {
      let returnParam = true;
      if (
        this.filter.space == "" &&
        this.filter.targetUser.length == 0 &&
        this.filter.status == 0
      ) {
        return true;
      } else if (item.linkedTargetId != undefined) {
        let targetList = item.linkedTargetId;
        if (this.filter.space != "") {
          returnParam = false;
          if (item.groupKbn === this.filter.space) {
            returnParam = true;
          }
        }
        if (this.filter.category.length > 0) {
          returnParam = false;
          if (this.filter.space === "PRO") {
            for (let j = 0; j < this.filter.category.length; j++) {
              if (item.groupId === this.filter.category[j]) {
                returnParam = true;
              }
            }
          } else {
            for (let j = 0; j < this.filter.category.length; j++) {
              if (item.projectId === this.filter.category[j]) {
                returnParam = true;
              }
            }
          }
        }
        if (this.filter.board.length > 0) {
          returnParam = false;
          for (let j = 0; j < this.filter.board.length; j++) {
            if (item.paperId === this.filter.board[j]) {
              returnParam = true;
            }
          }
        }

        if (this.filter.regUser != "") {
          let regUserReturnParam = false;
          returnParam = false;
          for (let i = 0; i < this.filter.regUser.length; i++) {
            if (item.chargerId === this.filter.regUser[i]) {
              regUserReturnParam = true;
            }
          }
          if (regUserReturnParam) {
            returnParam = true;
          }
        }
        if (this.filter.status != 0) {
          returnParam = false;
          let statusReturnParam = false;
          if (this.filter.status == 1 && item.terDate == null) {
            statusReturnParam = true;
          } else if (this.filter.status == 2 && item.terDate != null) {
            statusReturnParam = true;
          }

          if (statusReturnParam) {
            returnParam = true;
          }
        }
      } else {
        returnParam = false;
      }

      return returnParam;
    },

    getFilterCategoryName() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        categoryId: obj.filter.category,
      };
      if (obj.filter.category.length == 0) {
        obj.filter.categoryName = null;
      } else {
        reqData.req = obj.req;
        reqData.url = "/api/copaper/todo/getFilterCategoryName";
        reqData.method = "post";
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          obj.filter.categoryName = response.result;
        });
      }
    },
    getFilterBoardName() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        boardId: obj.filter.board,
      };
      reqData.req = obj.req;
      if (obj.filter.board.length == 0) {
        obj.filter.boardName = null;
      } else {
        reqData.url = "/api/copaper/todo/getFilterBoardName";
        reqData.method = "post";
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          obj.filter.boardName = response.result;
        });
      }
    },
    getFilterTargetUserName() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        userId: obj.filter.targetUser,
      };
      reqData.req = obj.req;
      if (obj.filter.targetUser.length == 0) {
        obj.filter.targetUserName = null;
      } else {
        reqData.url = "/api/copaper/todo/getFilterTargetUserName";
        reqData.method = "post";
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          obj.filter.targetUserName = response.result;
        });
      }
    },
    getFilterRegUserName() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        userId: obj.filter.regUser,
      };
      reqData.req = obj.req;
      if (obj.filter.regUser.length == 0) {
        obj.filter.regUserName = null;
      } else {
        reqData.url = "/api/copaper/todo/getFilterTargetUserName";
        reqData.method = "post";
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          obj.filter.regUserName = response.result;
        });
      }
    },

    openModal(param) {
      const obj = this;
      let request = {
        params: { paperId: param.paperId },
        req: self.req,
        url: "/api/copaper/paper/getPaperInfo",
        method: "post",
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(request)
        .then((response) => {
          if (response.errorCode) {
            console.log(result.errorCode);
          } else {
            const modalInfo = {
              obj: this.$modal,
              component: MyModal,
              width: "800px",
              // height: "665px",
              item: param,
              paperInfo: response.result,
              onclose: () => { this.sendRefreshBlock(param.paperId, param.deciId); }
            };
            this.showModal(modalInfo);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openModal2(param) {
      const modalInfo = {
        obj: this.$modal,
        component: MyModalU,
        width: "800px",
        // height: "665px",
        item: param,
        onclose: () => { this.sendRefreshBlock(param.paperId, param.deciId); }
      };
      this.showModal(modalInfo);
    },
    sendRefreshBlock(paperId, deciId) {
      const self = this;
      self.COWORK_REST_SIMPLE_ACTION({
        params: { by:"deci", paperId: paperId, deciId: deciId, update:true },
        url: "/api/copaper/paper/block/refreshBlockBy",
        method: "post",
      }).then((response) => { });
    },
    filterRefresh() {
      EventBus.$emit(
        "refreshFilterBoxDeci",
        "project_modal_PerDeci-FilterBoxDeci"
      );
    },

    replaceAll(str, input, output) {
      return str.split(input).join(output);
    },
    // setDisabledDate() {
    //   this.startDisabledDate.from = this.endDate;
    //   this.endDisabledDate.to = this.startDate;
    // },
    onPageChange(param) {
      let obj = this;
      if (param === "listFromFileList") {
        let reqData = {};
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listFromFileListPage,
        };
        reqData.req = obj.req;
        reqData.url = "/api/copaper/maindecision/listFromMePaging";
        reqData.method = "post";
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          this.listFromData = res.listFromMe;
          this.listFromSort();
        });
      } else if (param === "listToFileList") {
        let obj = this;
        let reqData = {};
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listToFileListPage,
        };
        reqData.req = obj.req;
        reqData.url = "/api/copaper/maindecision/listToMePaging";
        reqData.method = "post";
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          this.listToData = res.listToMe;
          this.listToSort();
        });
      }
    },
    addKanbanList(param) {
      let obj = this;
      let addDate = [];
      let reqData = {};
      reqData.req = obj.req;
      reqData.url = "/api/copaper/maindecision/addKanbanList";
      reqData.method = "post";
      if (param === "listToMeElse") {
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listToMeElse.length,
          kanbanName: param,
        };

        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          addDate = res.listToMeElse;
          for (let i = 0; i < addDate.length; i++) {
            this.listToMeElse.push(addDate[i]);
          }
          this.listToMeElseCount = res.listToMeElseCount;
          this.kanbanSort(addDate, "listToMeElse");
        });
      } else if (param === "listToMeAproval") {
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listToMeAproval.length,
          kanbanName: param,
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          addDate = res.listToMeAproval;
          for (let i = 0; i < addDate.length; i++) {
            this.listToMeAproval.push(addDate[i]);
          }
          this.listToMeCountAproval = res.listToMeCountAproval;
          this.kanbanSort(addDate, "listToMeAproval");
        });
      } else if (param === "listToMeReturn") {
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listToMeReturn.length,
          kanbanName: param,
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          addDate = res.listToMeReturn;
          for (let i = 0; i < addDate.length; i++) {
            this.listToMeReturn.push(addDate[i]);
          }
          this.listToMeCountReturn = res.listToMeCountReturn;
          this.kanbanSort(addDate, "listToMeReturn");
        });
      } else if (param === "listFromMeElse") {
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listFromMeElse.length,
          kanbanName: param,
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          console.log("칸반", response);
          let res = response.result;
          addDate = res.listFromMeElse;
          for (let i = 0; i < addDate.length; i++) {
            this.listFromMeElse.push(addDate[i]);
          }
          this.listFromMeElseCount = res.listFromMeElseCount;
          this.kanbanSort(addDate, "listFromMeElse");
        });
      } else if (param === "listFromMeAproval") {
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listFromMeAproval.length,
          kanbanName: param,
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          addDate = res.listFromMeAproval;
          for (let i = 0; i < addDate.length; i++) {
            this.listFromMeAproval.push(addDate[i]);
          }
          this.listFromMeCountAproval = res.listFromMeCountAproval;
          this.kanbanSort(addDate, "listFromMeAproval");
        });
      } else if (param === "listFromMeReturn") {
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listFromMeReturn.length,
          kanbanName: param,
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          addDate = res.listFromMeReturn;
          for (let i = 0; i < addDate.length; i++) {
            this.listFromMeReturn.push(addDate[i]);
          }
          this.listFromMeCountReturn = res.listFromMeCountReturn;
          this.kanbanSort(addDate, "listFromMeReturn");
        });
      }
    },
    handlerTabs3(index) {
      this.currentTab3 = index;
      if (index == 0) {
        this.currentTab4 = 0;
      } else {
        this.currentTab4 = 2;
      }
    },
    linkedTarget(type, param) {
      if (type == "PAPER") {
        window.open("/general/boardTarget/" + param.paperId +"/"+param.paperBlockId, "_blank");
      } else {
        if (type == "PRO") {
          window.open("/general/dashboard/" + param.projectId, "_blank");
        } else if (type == "CFRC") {
          window.open("/general/cooperation", "_blank");
        } else {
          return;
        }
      }
    },
    selectedStartDate(date) {
      // this.startDate = new Date(this.$moment(date).format("YYYY.MM.DD"));
      this.startDate = new Date(date);
      if (this.startDate > this.endDate) {
        this.endDate = this.startDate;
      }
      this.listMineAll();
    },
    selectedEndDate(date) {
      // this.endDate = new Date(this.$moment(date).format("YYYY.MM.DD"));
      this.endDate = new Date(date);
      if (this.startDate > this.endDate) {
        this.startDate = this.endDate;
      }
      this.listMineAll();
    },
    multiElipsis(ellipsisLine) {
      if (this.ellipsisTimer) {
        clearTimeout(this.ellipsisTimer);
      }

      this.ellipsisTimer = setTimeout(function () {
        if ($(".multi-ellipsis").length > 0) {
          var omle = $(".multi-ellipsis");
          var $txtR = $("<div class='txtEllipsis'></div>");
          var $body = $("body");
          omle.each(function (idx) {
            var _this = $(this);
            var orinalWidth = $(this).width();
            var txtOmle = _this.text();

            $txtR.text(txtOmle);
            $body.append($txtR);

            if ($txtR.width() >= orinalWidth * 1.2) {
              _this.addClass("no-ellipsis");
            } else {
              _this.removeClass("no-ellipsis");
            }
          });
        }
      }, 250);

      setTimeout(function () {
        $(".txtEllipsis").remove();
      }, 1000);
      // const obj = this;
      // $(window).on("load resize", function () {
      //   obj.multiElipsis(2);
      // });
    },
    checkDeciConfirm(){
      const self = this;
      self.COWORK_REST_SIMPLE_ACTION({
        url: "/api/copaper/maindecision/getCountDeciProcessByConfirmYn",
        method: "post",
        params: {}
      }).then((res) => { 
        self.deciReadYn = res.result;
      }).catch(function(err) {
        console.log(err);
      })
    }
  },
};
</script>
<style scoped>
.txtEllipsis {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  min-height: 23px;
  max-height: 2.8em;
  line-height: 1.4;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.6em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/PerDeci.vue